/* eslint-disable no-undef */
export default class WindowTrackingModule {
  constructor (store, config) {
    this.config = config.config
    this.store = store
    this.debug = false
    this.eventJson = require('./CciEventStrings.json')
  }

  init () {
    if (this.config.debug) {
      this.debug = this.config.debug
    }
  }

  trackEvent (contextKey, actionKey, obj, label, value) {
    var baseData = {'Context': this.eventJson[contextKey]}
    if (label !== undefined) {
      var labelData = {'Label': label}
      baseData = Object.assign(baseData, labelData)
    }
    if (value !== undefined) {
      var valueData = {'Value': value}
      baseData = Object.assign(baseData, valueData)
    }
    var issueData = Object.assign(baseData, this.getIssueData())
    if (obj !== undefined && obj.pageNumber !== undefined) {
      // We have a page object.
      var pageData = this.getPageData(obj)
      pageData = Object.assign(issueData, pageData)
      // Send event for first page
      this.sendEvent(actionKey, pageData)
      return
    } else if (obj !== undefined) {
      // obj is defined and not a page then it must be an article object.
      var articleData = this.getArticleData(obj)
      var articlePageData = this.getPageData(obj.page)
      var articleMergeData = Object.assign(issueData, articlePageData)
      articleMergeData = Object.assign(articleMergeData, articleData)
      // send event for article
      this.sendEvent(actionKey, articleMergeData)
      return
    }

    // Send event with issue data
    this.sendEvent(actionKey, issueData)
  }

  sendEvent (actionKey, data) {
    var event = new CustomEvent(this.eventJson[actionKey], { detail: data })
    if (this.debug) {
      console.log(event)
    }
    window.dispatchEvent(event)
  }

  getIssueData () {
    return {
      'PublicationName': this.store.state.publicationName,
      'IssueName': this.store.state.issueName,
      'IssueInternalName': this.store.state.issueInternalName,
      'IssueInternalId': this.store.state.issueInternalId,
      'PubDateDate': this.store.state.pubDateDate,
      'ZoneCont': this.store.state.zoneCont,
      'EditionCont': this.store.state.editionCont
    }
  }

  getPageData (singlePage) {
    return {
      'SectionName': singlePage.attributes.SectionName,
      'LayoutDeskCont': singlePage.attributes.LayoutDeskCont,
      'PageId': singlePage.id,
      'Page': singlePage.attributes.Page,
      'PageName': singlePage.attributes.Name
    }
  }

  getArticleData (article) {
    var byline = ''
    if (article.attributes.Byline !== undefined) {
      byline = article.attributes.Byline
    }
    var onlineUrl = ''
    if (article.attributes.onlineUrl !== undefined) {
      onlineUrl = article.attributes.OnlineURL
    }
    return {
      'ArticleInternalId': article.id,
      'ArticleInternaName': article.attributes.Name,
      'Headline': article.attributes.Headline,
      'Byline': byline,
      'OnlineURL': onlineUrl
    }
  }
}
/* eslint-enable no-undef */
